
<corp-pop-menu>
    <ng-template #trigger>
        <button 
            content-pop-trigger
            class="relative -mx-[5px] flex items-center text-black ltr:pr-[14px] rtl:pl-[14px] dark:text-white">
            <img src="/cdn/assets/common/user/anonymous.png" class="border-primary-200 inline-block h-[25px] w-[25px] rounded-full border-[2px] ltr:md:mr-[2px] ltr:lg:mr-[8px] rtl:md:ml-[2px] rtl:lg:ml-[8px]" alt="admin-image">
            <span class="block font-semibold text-[0] lg:text-base">
                {{ userInfo?.name }}
            </span>
            <i class="ri-arrow-down-s-line absolute top-1/2 mt-px -translate-y-1/2 text-[15px] ltr:-right-[3px] rtl:-left-[3px]"></i>
        </button>
    </ng-template>

    <ng-template #content>
        <div class="profile-menu-dropdown shadow-3xl absolute top-full z-[1] mt-[13px] w-max rounded-md bg-white py-[22px] transition-all md:mt-[14px] ltr:right-0 rtl:left-0 dark:bg-[#0c1427] dark:shadow-none">
            <div class="mx-[20px] mb-[10px] flex items-center pr-[20px]">
                <img src="/cdn/assets/common/user/anonymous.png" class="border-primary-200 inline-block h-[31px] w-[31px] rounded-full border-2 ltr:mr-[9px] rtl:ml-[9px]" alt="admin-image">
                <div>
                    <span class="block text-xs font-medium text-black dark:text-white">
                        {{ userInfo?.login }}
                    </span>
                    <span class="block text-xs">
                        {{ userInfo?.email }}
                    </span>
                </div>
            </div>

            <div class="mx-[40px] flex items-center">
                <i class="ri-shield-user-line text-[20px]"></i>
                Role(s)
            </div>
            <ul class="mx-[45px]">
                @for(role of userInfo?.roles; track role) {
                    <li class="relative mb-[7px] text-xs font-medium text-black last:mb-0 ltr:pl-[27px] rtl:pr-[27px] dark:text-white">
                        <i class="ri-check-line text-[20px] text-success-700"></i>
                        {{role}}
                    </li>
                }
            </ul>

            <div class="mx-[40px] flex items-center">
                <widget-theme-switcher (click)="switchTheme()" class="pr-[5px]"></widget-theme-switcher> 
                Theme: {{ currentTheme }}
            </div>

            <div class="mx-[40px] flex items-center">
                <widget-language-switcher class="pr-[5px]"></widget-language-switcher> 
                Langue: {{ currentLanguage }}
            </div>


            <div class="mx-[20px] my-[20px] border-t border-gray-100 dark:border-[#172036]"></div>

            <div class="mx-[20px] mb-[10px] flex items-center pb-[5px]">
                <img 
                    [src]="'/cdn/assets/logo/apps/' + _appSettingService.appSetting()?.application?.name?.toLowerCase() + '.png'" 
                    class="border-primary-200 inline-block h-[31px] w-[31px] rounded-full border-2 ltr:mr-[9px] rtl:ml-[9px]" 
                    alt="admin-image">
                <div>
                    <span class="block text-sm font-medium text-black dark:text-white">
                        {{ _appSettingService.appSetting()?.application?.name }}
                    </span>
                </div>
            </div>

            <div class="mx-[40px] my-[9px] flex items-center">
                <i class="ri-box-3-line text-[20px]"></i>
                
                <!-- <i class="material-symbols-outlined inline-block h-[10px] w-[10px] rounded-full bg-gray-100 text-center !text-lg !leading-[10px] text-gray-500 ltr:mr-[10px] rtl:ml-[10px] dark:bg-[#172036] dark:text-gray-400">
                    deployed_code_history
                </i> -->
                Version: {{ _appSettingService.appSetting()?.application?.version }}
            </div>
        </div>
    </ng-template>
</corp-pop-menu>
